import { render, staticRenderFns } from "./VisualizacoesComprasLine.vue?vue&type=template&id=28236ace&"
import script from "./VisualizacoesComprasLine.vue?vue&type=script&lang=js&"
export * from "./VisualizacoesComprasLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports